module.exports = __webpack_public_path__ + "img/tums_extra_strength_750_antacid_chewy_bites_assorted_berries.b5af1be9.png";